import React from 'react'
import { CImg, CCardHeader, CImage,
         CCardTitle, CCard,
         CCardBody,
         CCardFooter, CCol, CRow,
} from 'compat/coreui';

export default function BusinessDeals({seller}) {

    return (
        <div>
            <CCard className="business-dashboard-new">
                <div className="biz_module biz_menu c_12 doaj" data-position="rig">
                  <h3>Deals</h3>
                    <div className="seller-details m-5">
                      <CRow>
                        {(seller.deals)&& seller.deals.map((dealItem, i) =>
                         {return(<CCol sm={4} className="m-auto" key={i}>
                                  <CCard className="deal-page-card">
                                    <CCardHeader className="p-0 b-header">
                                      <CImage src="/images/jack.png" width="100%" />
                                    </CCardHeader>
                                    <CCardBody className="text-center">
                                      <CCardTitle>
                                        <p>{dealItem.title}</p>
                                      </CCardTitle>
                                    </CCardBody>
                                    <CCardFooter className="biz-deal deal-footer">
                                      <span>Flower</span><span>Both</span><span> 2096</span>
                                    </CCardFooter>
                                  </CCard>
                                </CCol>)
                          })}
                      </CRow>
                    </div>
                </div>
            </CCard>
        </div>
    )
}